import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SharedService } from "@shared/services/shared.service";
import { ISaveAdminBusiness } from "app/models/admin/admin";
import { IBusinessView } from "app/models/business/business";
// import { IBusinessView } from "app/models/mainMenu/mainMenu";
import { IReportSelectItems, ISelectItems } from "app/models/shared/shared";
import { AdminService } from "app/services/admin/admin.service";


@Component({
  selector: 'editBusiness',
  templateUrl: './editBusiness.component.html'
})

export class EditBusinessComponent implements OnInit {

  countySelected: string = '';
  countyList = this.sharedService.countyDropDownList;
  showList: boolean = false;
  actionableComplaint: boolean = false;
  searchList: IBusinessView[] = [];
  resultsCount: number = 0;
  filter: string = '';
  businessId: string = '';
  businessList: ISelectItems[] = [];
  getExemptTypeOptionsList: ISelectItems[] = [];
  getExemptStatusOptionsList: ISelectItems[] = [];
  selectStatusList: IReportSelectItems[] = [];
  statusList: IReportSelectItems[] = [];
  nonActionableList: ISelectItems[] = [];
  savedComplaints: boolean = false;
  exemptList: boolean = false;
  currentBusinessLocal: IBusinessView = null;
  newBusiness: boolean = false;
  savedBusiness: boolean = false;

  currentSave: ISaveAdminBusiness = {
    businessId: 0,
    businessName: '',
    businessType: 0,
    active: false,
    exempt: false,
    businessAddress1: '',
    businessAddress2: '',
    businessCity: '',
    businessZip: '',
    businessZipExt: '',
    countyId: '',
    exemptCertificateDate: '',
    exemptStatusId: '',
    exemptTypeId: '',
    exemptSmokingAllowed: false,
    exemptApprovedBy: '',
    exemptEnteredBy: ''
  };

  businessForm = new UntypedFormGroup({
    businessId: new UntypedFormControl('', [Validators.required]),
    businessName: new UntypedFormControl('', [Validators.required]),
    businessType: new UntypedFormControl('', [Validators.required]),
    active: new UntypedFormControl(false),
    exempt: new UntypedFormControl(false),
    businessAddress1: new UntypedFormControl('', [Validators.required]),
    businessAddress2: new UntypedFormControl(''),
    businessCity: new UntypedFormControl('', [Validators.required]),
    businessZip: new UntypedFormControl('', [Validators.required]),
    businessZipExt: new UntypedFormControl(''),
    countyId: new UntypedFormControl('', [Validators.required]),
    exemptCertificateDate: new UntypedFormControl(''),
    exemptStatusId: new UntypedFormControl(''),
    exemptTypeId: new UntypedFormControl(''),
    exemptSmokingAllowed: new UntypedFormControl(false),
    exemptApprovedBy: new UntypedFormControl(''),
    exemptEnteredBy: new UntypedFormControl('')
  });

  public form = new UntypedFormGroup({
    orelapId: new UntypedFormControl('', [Validators.required]),
    labelPosition: new UntypedFormControl('1', [Validators.required])
  });

  constructor(
    private sharedService: SharedService,
    private adminService: AdminService,
    private dialogRef: MatDialogRef<EditBusinessComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // this.currentBusinessLocal = this.adminService.currentBusiness;
    this.currentBusinessLocal = this.data.business;
    this.newBusiness = this.data.newBusiness;
    if (this.currentBusinessLocal == null) {
      // this.newBusiness = true;
      this.clearSave();
      this.setParameters();
      this.setExemptStatus(false);
    }
    else {
      // this.newBusiness = false;
      this.setSave(this.currentBusinessLocal);
      this.setParameters();
      this.setExemptStatus(this.currentSave.exempt);
    }
  }

  ngOnInit(): void {
    this.businessList = this.sharedService.businessTypeDropDownList;
    this.savedBusiness = false;
    this.getStatuses();
    let status = false;
    if (this.currentBusinessLocal == null || this.currentBusinessLocal == undefined){
      this.businessForm.controls['active'].setValue(true);
    }
    else {
      status = this.currentBusinessLocal.exempt
    }
    this.setExemptStatus(status);
  }

  getBusiness() {
    this.adminService.getNonActionable().subscribe({
      next: response => {
        this.nonActionableList = response;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Non-Actionable Data");
      },
    });
  }

  getStatuses() {
    this.adminService.getNonActionable().subscribe({
      next: response => {
        this.nonActionableList = response;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Non-Actionable Data");
      },
    });

    this.adminService.getExemptTypeOptionsList().subscribe({
      next: response => {
        this.getExemptTypeOptionsList = response;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Non-Actionable Data");
      },
    });

    this.adminService.getExemptStatusOptionsList().subscribe({
      next: response => {
        this.getExemptStatusOptionsList = response;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Non-Actionable Data");
      },
    });

  }

  exemptChange(event: any) {
    this.setExemptStatus(event.checked);
  }

  setExemptStatus(status: boolean) {
    if (status) {
      this.exemptList = true;
      this.businessForm.controls['exemptCertificateDate'].addValidators(Validators.required);
      this.businessForm.controls['exemptStatusId'].addValidators(Validators.required);
      this.businessForm.controls['exemptTypeId'].addValidators(Validators.required);
    }
    else {
      this.exemptList = false;
      this.businessForm.controls['exemptCertificateDate'].removeValidators([Validators.required]);
      this.businessForm.controls['exemptCertificateDate'].updateValueAndValidity();
      this.businessForm.controls['exemptStatusId'].removeValidators([Validators.required]);
      this.businessForm.controls['exemptStatusId'].updateValueAndValidity();
      this.businessForm.controls['exemptTypeId'].removeValidators([Validators.required]);
      this.businessForm.controls['exemptTypeId'].updateValueAndValidity();
    }
  }

  save() {
    if (this.businessForm.valid) {
      this.setBusinessParam();

      if (this.currentSave.businessId == 0) {
        this.adminService.saveNewBusiness(this.currentSave).subscribe({
          next: response => {
            this.sharedService.toastr.success("Business Saved");
            this.savedBusiness = true;
            this.savedComplaints = true;
            this.return();
          },
          error: e => {
            this.sharedService.toastr.error("Could not save New Business");
          },
        });
      }
      else {
        this.adminService.saveBusinessAdmin(this.currentSave).subscribe({
          next: response => {
            this.sharedService.toastr.success("Business Saved");
            this.savedBusiness = true;
            this.savedComplaints = true;
            this.return();
          },
          error: e => {
            this.sharedService.toastr.error("Could not save Business Admin");
          },
        });
      }
    }
    else {
      this.sharedService.toastr.error("Form is not valid");
    }
  }

  setSave(business: IBusinessView) {
    this.currentSave.businessId = business.id;
    this.currentSave.businessName = business.businessName;
    this.currentSave.businessType = business.businessType;
    this.currentSave.active = business.active;
    this.currentSave.exempt = business.exempt;
    this.currentSave.businessAddress1 = business.businessAddress1;
    this.currentSave.businessAddress2 = business.businessAddress2;
    this.currentSave.businessCity = business.businessCity;
    this.currentSave.businessZip = business.businessZip;
    this.currentSave.businessZipExt = business.businessZipExt;
    this.currentSave.countyId = business.countyId;
    this.currentSave.exemptCertificateDate = business.exemptCertificateDate;
    this.currentSave.exemptStatusId = business.exemptStatusId != null ? business.exemptStatusId.toString() : '';
    this.currentSave.exemptTypeId = business.exemptTypeId != null ? business.exemptTypeId.toString() : '';
    this.currentSave.exemptSmokingAllowed = business.exemptSmokingAllowed;
    this.currentSave.exemptApprovedBy = business.exemptApprovedBy;
    this.currentSave.exemptEnteredBy = business.exemptEnteredBy;
  }

  setBusinessParam() {
    let tempForm = this.businessForm.getRawValue();
    this.currentSave.businessId = tempForm.businessId;
    this.currentSave.businessName = tempForm.businessName;
    this.currentSave.businessType = tempForm.businessType;
    this.currentSave.active = tempForm.active;
    this.currentSave.exempt = tempForm.exempt;
    this.currentSave.businessAddress1 = tempForm.businessAddress1;
    this.currentSave.businessAddress2 = tempForm.businessAddress2;
    this.currentSave.businessCity = tempForm.businessCity;
    this.currentSave.businessZip = tempForm.businessZip;
    this.currentSave.businessZipExt = tempForm.businessZipExt;
    this.currentSave.countyId = tempForm.countyId;
    this.currentSave.exemptCertificateDate = tempForm.exemptCertificateDate;
    this.currentSave.exemptStatusId = tempForm.exemptStatusId;
    this.currentSave.exemptTypeId = tempForm.exemptTypeId;
    this.currentSave.exemptSmokingAllowed = tempForm.exemptSmokingAllowed;
    this.currentSave.exemptApprovedBy = tempForm.exemptApprovedBy;
    this.currentSave.exemptEnteredBy = tempForm.exemptEnteredBy;
  }

  clearSave() {
    this.currentSave.businessId = 0;
    this.currentSave.businessName = '';
    this.currentSave.businessType = 0;
    this.currentSave.active = false;
    this.currentSave.exempt = false;
    this.currentSave.businessAddress1 = '';
    this.currentSave.businessAddress2 = '';
    this.currentSave.businessCity = '';
    this.currentSave.businessZip = '';
    this.currentSave.businessZipExt = '';
    this.currentSave.countyId = '';
    this.currentSave.exemptCertificateDate = '';
    this.currentSave.exemptStatusId = '';
    this.currentSave.exemptTypeId = '';
    this.currentSave.exemptSmokingAllowed = false;
    this.currentSave.exemptApprovedBy = '';
    this.currentSave.exemptEnteredBy = ''
  }

  setParameters() {
    this.businessForm.controls['businessId'].setValue(this.currentSave.businessId);
    this.businessForm.controls['businessName'].setValue(this.currentSave.businessName);
    this.businessForm.controls['businessType'].setValue(this.currentSave.businessType.toString());
    this.businessForm.controls['active'].setValue(this.currentSave.active);
    this.businessForm.controls['exempt'].setValue(this.currentSave.exempt);
    this.businessForm.controls['businessAddress1'].setValue(this.currentSave.businessAddress1);
    this.businessForm.controls['businessAddress2'].setValue(this.currentSave.businessAddress2);
    this.businessForm.controls['businessCity'].setValue(this.currentSave.businessCity);
    this.businessForm.controls['businessZip'].setValue(this.currentSave.businessZip);
    this.businessForm.controls['businessZipExt'].setValue(this.currentSave.businessZipExt == null ? '' : this.currentSave.businessZipExt.toString());
    this.businessForm.controls['countyId'].setValue(this.currentSave.countyId == null ? '' : this.currentSave.countyId.toString());
    this.businessForm.controls['exemptCertificateDate'].setValue(new Date(this.currentSave.exemptCertificateDate));
    this.businessForm.controls['exemptStatusId'].setValue(this.currentSave.exemptStatusId.toString());
    this.businessForm.controls['exemptTypeId'].setValue(this.currentSave.exemptTypeId.toString());
    this.businessForm.controls['exemptSmokingAllowed'].setValue(this.currentSave.exemptSmokingAllowed);
    this.businessForm.controls['exemptApprovedBy'].setValue(this.currentSave.exemptApprovedBy);
    this.businessForm.controls['exemptEnteredBy'].setValue(this.currentSave.exemptEnteredBy);
  }

  return(): void {
    let returnData = this.savedBusiness? 'saved' : 'cancel';
    this.dialogRef.close(returnData);
  }
  
}